import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import { Button, Checkbox, Divider, Input, message, Select, Spin, Tabs, Transfer } from 'antd';
import { getPanelMaxWidth, getPanelWidth, getPanelMaxHeight } from '@/services/helper/panelSizeHelper';
import auroraDBJson from '../../../../services/Designs/auroraDbData';
import { getCascadeComponents } from '../../../../services/Cascade/helper/setupData';
import { CAP, CONNECTOR, DIODE, FERRITE, IND, JUMPER, LOAD, PMIC, RES, SWITCH, TRANSISTOR } from '../../../../constants/componentType';
import componentSetting from '../../../../services/Cascade/helper/compSettingHelper';
import '../Tree/tree.css'

const ComponentTypes = [RES, IND, JUMPER, FERRITE, TRANSISTOR, SWITCH, DIODE, PMIC, LOAD]
class EditPanel extends Component {
  constructor(props) {
    super(props);
    const { data } = props;
    const { pins } = data;
    this.state = {
      maxWidth: 600,
      maxHeight: 550,
      key: 'compInfo',
      component: {},
      saved: {},
      nextComponents: [],
      loading: false,
      pins,
      error: "",
      ground: false
    };
    this.dialogRoot = document.getElementById('root');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 600),
      maxHeight: getPanelMaxHeight(offset, 550),
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getComponentInfo()
  }

  closeModal = () => {
    this.props.closePanel();
  }

  saveDatas = () => {
    const { saved, tracePaths, prevNet, ground } = this.state;
    const { designId } = this.props;
    if (saved['deep']) {
      const { data, columnIndex } = this.props;
      const { deep } = data;
      if (String(deep) !== String(saved['deep'])) {
        const except = data.number ? Array.from({ length: data.number }, (_, i) => Number(deep) + i) : [deep]
        const error = this.props.checkDeep(columnIndex, saved['deep'], except);
        if (error) {
          this.setState({
            error
          })
          return;
        }
      }
    }
    if (tracePaths && tracePaths.length) {
      const paths = tracePaths.map(path => path.checked ? path.path : null).filter(item => !!item);
      saved['paths'] = paths;
      saved['designId'] = designId;
      saved['prevNet'] = prevNet;
      saved['ground'] = ground;
    }
    this.props.editTreeComponent(saved);
  }

  changeKey = (key) => {
    this.setState({ key })
  }

  changeSavedData = (key, value) => {
    this.setState({
      saved: {
        ...this.state.saved,
        [key]: value
      },
      error: ""
    })
  }

  getComponentInfo = async () => {
    const { designId, name } = this.props;
    try {
      if (!auroraDBJson.checkAuroraJson(designId)) {
        const setting = componentSetting.getSetting({ designId });
        await auroraDBJson.getAuroraJson(designId, setting);
      }
      const component = getCascadeComponents({ pcbId: designId, name })
      this.setState({
        component
      })
    } catch (error) {
      console.error(error);
      message.error('Get component information failed!')
    }
  }

  changeTransfer = (targetKeys) => {
    const { component } = this.state;
    const { pins } = component;
    const newPins = [...pins.values()].filter(pin => targetKeys.includes(pin.pin));
    this.changeSavedData('pins', newPins);
    this.setState({
      pins: newPins
    })
  }

  getNextComponents = (net) => {
    const { designId, name } = this.props;
    const components = auroraDBJson.getComponentsByNets(designId, [net]);
    const nextComponents = components.filter(item => item.name !== name && item.type !== CAP).map(item => item.name).sort()
    this.setState({
      nextComponents,
      prevNet: net
    })
  }

  saveNextComponent = (comp) => {
    this.setState({
      nextComponent: comp
    })
  }

  traceNextComponent = async () => {
    this.setState({
      loading: true
    }, async () => {
      const { nextComponent, prevNet } = this.state;
      const { data, designId } = this.props;
      const { id } = data;
      const paths = await this.props.traceByComponent(id, nextComponent, prevNet, designId)
      const tracePaths = paths.sort((a, b) => a.length - b.length).map((path, index) => {
        let topology = [{ type: 'net', name: prevNet }];
        path.forEach(item => {
          const { name, nextNet } = item;
          topology.push(...[{ type: 'comp', name }])
          if (nextNet) {
            topology.push(...[{ type: 'net', name: nextNet }])
          }
        })
        return { index, topology, checked: false, path }
      })
      this.setState({
        tracePaths,
        loading: false
      })
    })
  }

  selectTopology = (e, index) => {
    const { tracePaths } = this.state;
    let _tracePaths = [...tracePaths];
    _tracePaths[index].checked = e.target.checked;
    this.setState({
      tracePaths: _tracePaths
    })
  }

  setAsGndPaths = (e) => {
    this.setState({
      ground: e.target.checked
    })
  }

  infoRender = () => {
    const { data } = this.props;
    const { type, deep } = data;
    return <div className='power-tree-edit-tab'>
      <div className='power-tree-edit-tab-content'>
        <span className='power-tree-edit-tab-title'>Type</span>
        <Select
          className='power-tree-edit-tab-box'
          size='small'
          defaultValue={type}
          options={ComponentTypes.map(option => ({ value: option, label: option }))}
          onChange={(value) => this.changeSavedData('type', value)}
          disabled={type === CONNECTOR ? true : false}
        />
        <span className='power-tree-edit-tab-title'>Vertical coordinate</span>
        <Input
          className='power-tree-edit-tab-box'
          size='small'
          defaultValue={deep}
          onChange={(e) => this.changeSavedData('deep', e.target.value)}
        />
      </div>
      <Divider style={{ margin: '12px 0' }} />
      <div className='power-tree-edit-tab-content'>
        <span className='power-tree-edit-tab-title'>Pins</span>
      </div>
      <div className='power-tree-edit-tab-content'>
        {this.transRender()}
      </div>
    </div>
  }

  transRender = () => {
    const { component, pins: targetPins } = this.state;
    if (!component || !component.pins) {
      return;
    }
    const { pins } = component;
    const pinSource = [...pins.values()].map(pin => ({ key: pin.pin, title: `${pin.pin}::${pin.pinName} (${pin.net})` }));
    const targetKeys = targetPins.map(pin => pin.pin)
    return <Transfer
      className='power-tree-edit-tab-transfer'
      titles={['Not selected', 'Selected']}
      locale={{
        itemUnit: 'Pin',
        itemsUnit: 'Pins',
        searchPlaceholder: 'Search Pins'
      }}
      showSearch={true}
      dataSource={pinSource}
      targetKeys={targetKeys}
      onChange={this.changeTransfer}
      render={(item) => item.title}
      filterOption={(inputValue, item) =>
        (item.title || "").toLowerCase().indexOf((inputValue || "").toLowerCase()) !== -1
      }
    />
  }

  addRender = () => {
    const { data } = this.props;
    const { prev } = data;
    const prevNets = prev.map(item => item.prevNet);
    const { component, nextComponents, nextComponent, tracePaths, loading, ground } = this.state;
    if (!component || !component.pins) {
      return;
    }
    const { pins } = component;
    const nextNets = [...new Set([...pins.values()].map(pin => pin.net))].filter(net => !prevNets.includes(net));
    return <div className='power-tree-edit-tab'>
      <Spin spinning={loading}>
        <div className='power-tree-edit-tab-content'>
          <span className='power-tree-edit-tab-title'>Net</span>
          <Select
            className='power-tree-edit-tab-box'
            size='small'
            defaultValue={""}
            options={nextNets.map(option => ({ value: option, label: option }))}
            onChange={(value) => this.getNextComponents(value)}
            showSearch={true}
          />
          <span className='power-tree-edit-tab-title'>Component</span>
          <Select
            className='power-tree-edit-tab-box power-tree-edit-tab-component-box'
            size='small'
            defaultValue={""}
            options={nextComponents.map(option => ({ value: option, label: option }))}
            onChange={(value) => this.saveNextComponent(value)}
            showSearch={true}
          />
          <Button size='small' disabled={!nextComponent} onClick={this.traceNextComponent}>Search</Button>
        </div>
        <div className='power-tree-edit-set-gnd-box'>
          <Checkbox onChange={(e) => this.setAsGndPaths(e)} checked={ground}>Set as ground paths</Checkbox>
        </div>
        {
          tracePaths && tracePaths.length ? <div className='power-tree-edit-tab-checkbox-groups'>
            {
              tracePaths.map(path => {
                const { topology, index, checked } = path;
                let string = topology.reduce((prev, item, itemIndex) => {
                  const { type, name } = item;
                  const label = type === 'comp' ? `[${name}]` : name;
                  if (itemIndex === topology.length - 1) {
                    return prev + label
                  }
                  return prev + label + ' -> ';
                }, '')
                return <Checkbox onChange={(e) => this.selectTopology(e, index)} checked={checked} key={index}>
                  {string}
                </Checkbox>
              })
            }
          </div> : null
        }
      </Spin>
    </div>
  }

  errorRender = () => {
    const { error } = this.state;
    if (!error) {
      return null;
    }
    return <span className='power-tree-edit-error'>Error: {error}</span>
  }

  render() {
    const { maxWidth, maxHeight, key } = this.state;
    const { name, type } = this.props;
    const items = type === LOAD ? [{ key: 'compInfo', label: 'Component information', children: this.infoRender() }]
      : [{ key: 'compInfo', label: 'Component information', children: this.infoRender() }, { key: 'compAdd', label: 'Add next component', children: this.addRender() }]
    const content = (
      <Panel
        className='cascade-power-select-panel'
        title={<div className='cascade-power-select-title'>{`${name}`}</div>}
        onCancel={this.closeModal}
        zIndex={2000}
        width={getPanelWidth(maxWidth, { defaultWidth: 600 })}
        height={550}
        maxHeight={maxHeight}
        position='panel-center'
        draggable
        minHeight={550}
        minWidth={400}
        defaultTop={200}
        footer={<Button size='small' onClick={this.saveDatas}>Save</Button>}
      >
        <Tabs activeKey={key} items={items} onChange={this.changeKey} className='power-tree-edit-tabs' />
        {this.errorRender()}
      </Panel >
    )
    return createPortal(content, this.dialogRoot);
  }
};


export default EditPanel;
